import svgContent from '../assets/AAA_Sizing_Sheet.svg?raw';
import { getMeasurementFromPlaceholder } from '../domain/evar-svg-mapping';

import { SvgSizingSheet } from '@/workflows/vascular/common/components/svg-sizing-sheet';

export function EvarSizingSheet() {
    return (
        <SvgSizingSheet
            svgContent={svgContent}
            getMeasurementFromPlaceholder={getMeasurementFromPlaceholder}
        />
    );
}
